export class CalendarInfo {
  constructor(calendarId, name, color, bgColor, borderColor, dragBgColor) {
    this.id = "" + calendarId;
    this.name = name || "My Calendar" + this.id;
    this.color = color;
    this.backgroundColor = bgColor;
    this.borderColor = borderColor;
    this.dragBackgroundColor = dragBgColor;
    this.checked = true;
  }
}

export const generate_calendar = (data) => {
  if (data) {
    let calendarInfo = data.selected_calendar.map((dc) => {
      if (dc.selected) {
        return new CalendarInfo(
          dc.id,
          dc.calendarName,
          dc.foregroundColor,
          dc.backgroundColor,
          dc.backgroundColor,
          dc.backgroundColor,
        );
      }
    });
    let filter_calendarInfo = calendarInfo.filter((ci) => {
      return ci != undefined;
    });
    return filter_calendarInfo;
  }
};
